import { Input } from 'antd/lib';
import React from 'react';

import { useTranslation } from 'react-i18next';

import styles from './TextInput.module.css';

interface TextInputProps {
  name?: string;
  value?: string;
  placeholder?: string;
  className?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  label?: string;
  labelTooltip?: React.ReactNode;
  disabled?: boolean;
  required?: boolean;
  noSpacing?: boolean;
  [key: string]: TypeAny;
}

export function TextInput({
  name,
  value,
  onChange,
  placeholder,
  className = '',
  required = false,
  labelTooltip,
  noSpacing,
  error,
  label,
  disabled,
  ...props
}: TextInputProps) {
  const { t } = useTranslation();
  return (
    <div className={`${styles.textInputWrap} ${noSpacing ? styles.noSpacing : ''}`}>
      {label && (
        <span className={styles.textInputLabel}>
          {label}
          {required && ' *'}
          {labelTooltip}
        </span>
      )}
      <Input
        value={value}
        status={error && 'error'}
        required={required}
        placeholder={placeholder || t('placeholder.data')}
        name={name}
        onChange={onChange}
        disabled={disabled}
        className={`${styles.textInput} ${(props.addonAfter || props.addonBefore) && styles.addon} ${className}`}
        {...props}
      />
      <p className={styles.textInputError}>{error}</p>
    </div>
  );
}
